var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopic31(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1140 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#212c42;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15{stroke-width:0px;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-6);}.cls-4{fill:#1c2538;}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:gray;}.cls-7,.cls-12{fill:#fff;}.cls-8{fill:url(#linear-gradient-2);}.cls-9{fill:#d4d8df;}.cls-10{fill:url(#linear-gradient-3);}.cls-11{fill:#3bc81e;}.cls-12{opacity:.25;}.cls-13{fill:#eb0037;}.cls-14{fill:url(#linear-gradient-4);}.cls-15{fill:#ecbb0a;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 222.82,
    y1: 295.85,
    x2: 914.7,
    y2: 295.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#46acef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a59be"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 570,
    y1: 734.71,
    x2: 570,
    y2: 445.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d5d8de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727c92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 519.4,
    y1: 262.34,
    x2: 519.4,
    y2: 487.5,
    gradientTransform: "translate(-14.41 -53.97) rotate(-1.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d61e24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#d11d23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#ba1a1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#ac181b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#a8181b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 586.44,
    y1: 262.34,
    x2: 586.44,
    y2: 487.5,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 614.14,
    y1: 106.08,
    x2: 614.14,
    y2: 331.25,
    gradientTransform: "translate(32.34 48.59) rotate(4.04)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 508.8,
    y1: 106.08,
    x2: 508.8,
    y2: 243.95,
    gradientTransform: "translate(32.34 48.59) rotate(4.04)",
    xlinkHref: "#linear-gradient-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m95.01,705.33l7.45,18.86c2.82,7.14,9.72,11.83,17.39,11.83h901.68c8.14,0,15.34-5.26,17.81-13.01l5.64-17.67H95.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m937.02,519.04H202.98V93.98c0-16.57,13.43-30,30-30h674.05c16.57,0,30,13.43,30,30v425.06Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "222.82 500.44 222.82 91.27 914.7 91.27 914.7 500.44 222.82 500.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m202.98,519.04l-108.16,177.94c-3.14,5.16.58,11.77,6.62,11.77h937.13c6.04,0,9.76-6.61,6.62-11.77l-108.16-177.94H202.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m489.67,650.73l-11.07,30.61c-2.21,6.12,2.32,12.58,8.83,12.58h163.57c6.47,0,11-6.39,8.86-12.5l-10.75-30.61c-1.32-3.76-4.87-6.28-8.86-6.28h-141.75c-3.95,0-7.48,2.48-8.83,6.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m281.06,629.82h-86.37c-.91,0-1.5-.96-1.08-1.77l5.28-10.18c.21-.4.62-.65,1.08-.65h81.09c.67,0,1.21.54,1.21,1.21v10.18c0,.67-.54,1.21-1.21,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m310.77,593.95h-97.44c-.91,0-1.5-.97-1.08-1.78l4.24-8.12c.21-.4.62-.65,1.08-.65h93.2c.67,0,1.21.54,1.21,1.21v8.12c0,.67-.54,1.21-1.21,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m293.31,577.94h-72.41c-.92,0-1.51-.99-1.07-1.8l4.43-8.12c.21-.39.62-.63,1.07-.63h67.99c.67,0,1.21.54,1.21,1.21v8.12c0,.67-.54,1.21-1.21,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m274.47,562.25h-45c-.91,0-1.49-.96-1.08-1.76l3.24-6.39c.21-.41.63-.67,1.08-.67h41.76c.67,0,1.21.54,1.21,1.21v6.39c0,.67-.54,1.21-1.21,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m274.47,549.3h-37.85c-.92,0-1.5-.98-1.07-1.79l2.5-4.66c.21-.39.62-.64,1.07-.64h35.34c.67,0,1.21.54,1.21,1.21v4.66c0,.67-.54,1.21-1.21,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m256.49,612.02h-52.19c-.9,0-1.49-.94-1.09-1.75l5.02-10.18c.2-.41.63-.68,1.09-.68h47.17c.67,0,1.21.54,1.21,1.21v10.18c0,.67-.54,1.21-1.21,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m776.52,629.31h163.19c1.23,0,2.02-1.3,1.45-2.39l-4.84-9.33c-.28-.54-.84-.88-1.45-.88h-158.35c-.91,0-1.64.73-1.64,1.64v9.33c0,.91.73,1.64,1.64,1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m846.73,593.44h72.5c2.07,0,3.4-2.19,2.44-4.03l-2.63-5.04c-.47-.91-1.41-1.48-2.44-1.48h-69.87c-1.52,0-2.75,1.23-2.75,2.75v5.04c0,1.52,1.23,2.75,2.75,2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m865.28,577.43h46.33c2.09,0,3.42-2.24,2.42-4.07l-2.75-5.04c-.48-.88-1.41-1.43-2.42-1.43h-43.58c-1.52,0-2.75,1.23-2.75,2.75v5.04c0,1.52,1.23,2.75,2.75,2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m862.17,562.25h40.96c2.05,0,3.38-2.17,2.45-4l-1.68-3.31c-.47-.92-1.42-1.51-2.45-1.51h-39.28c-1.52,0-2.75,1.23-2.75,2.75v3.31c0,1.52,1.23,2.75,2.75,2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m862.17,548.79h33.74c2.08,0,3.41-2.22,2.42-4.06l-.85-1.58c-.48-.89-1.41-1.45-2.42-1.45h-32.89c-1.52,0-2.75,1.23-2.75,2.75v1.58c0,1.52,1.23,2.75,2.75,2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m847.22,611.51h81.11c2.04,0,3.37-2.14,2.47-3.97l-3.5-7.11c-.46-.94-1.42-1.54-2.47-1.54h-77.61c-1.52,0-2.75,1.23-2.75,2.75v7.11c0,1.52,1.23,2.75,2.75,2.75Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 295.37,
    y: 617.06,
    width: 48.93,
    height: 12.61,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 352.83,
    y: 617.06,
    width: 48.93,
    height: 12.61,
    rx: 0.86,
    ry: 0.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 411.08,
    y: 617.06,
    width: 48.93,
    height: 12.61,
    rx: 0.86,
    ry: 0.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 470.83,
    y: 617.06,
    width: 48.93,
    height: 12.61,
    rx: 1.08,
    ry: 1.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 531.93,
    y: 617.06,
    width: 28.32,
    height: 12.61,
    rx: 1.08,
    ry: 1.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 571.46,
    y: 617.06,
    width: 28.32,
    height: 12.61,
    rx: 0.79,
    ry: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 612.18,
    y: 617.06,
    width: 28.32,
    height: 12.61,
    rx: 0.79,
    ry: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 652.09,
    y: 617.06,
    width: 28.32,
    height: 12.61,
    rx: 0.88,
    ry: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 695.86,
    y: 617.06,
    width: 28.32,
    height: 12.61,
    rx: 0.88,
    ry: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 735.37,
    y: 617.06,
    width: 28.32,
    height: 12.61,
    rx: 0.87,
    ry: 0.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 266.18,
    y: 599.41,
    width: 31.86,
    height: 12.61,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 307.64,
    y: 599.41,
    width: 31.86,
    height: 12.61,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 349.1,
    y: 599.41,
    width: 31.86,
    height: 12.61,
    rx: 0.96,
    ry: 0.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 390.56,
    y: 599.41,
    width: 31.86,
    height: 12.61,
    rx: 0.86,
    ry: 0.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 432.02,
    y: 599.41,
    width: 31.86,
    height: 12.61,
    rx: 0.66,
    ry: 0.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 473.48,
    y: 599.41,
    width: 31.86,
    height: 12.61,
    rx: 1.08,
    ry: 1.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 514.94,
    y: 599.41,
    width: 31.86,
    height: 12.61,
    rx: 1.08,
    ry: 1.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 556.4,
    y: 599.41,
    width: 31.86,
    height: 12.61,
    rx: 0.79,
    ry: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 597.86,
    y: 599.41,
    width: 31.86,
    height: 12.61,
    rx: 0.79,
    ry: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 639.32,
    y: 599.41,
    width: 31.86,
    height: 12.61,
    rx: 0.88,
    ry: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 680.78,
    y: 599.41,
    width: 31.86,
    height: 12.61,
    rx: 0.88,
    ry: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 722.25,
    y: 599.41,
    width: 31.86,
    height: 12.61,
    rx: 0.87,
    ry: 0.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 763.71,
    y: 599.41,
    width: 31.86,
    height: 12.61,
    rx: 0.87,
    ry: 0.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 805.17,
    y: 599.41,
    width: 31.86,
    height: 12.61,
    rx: 1.46,
    ry: 1.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 322.05,
    y: 583.41,
    width: 45.95,
    height: 10.54,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 300.59,
    y: 567.4,
    width: 57.57,
    height: 10.54,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 377.3,
    y: 583.41,
    width: 41.09,
    height: 10.54,
    rx: 0.86,
    ry: 0.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 425.54,
    y: 583.41,
    width: 33.94,
    height: 10.54,
    rx: 0.86,
    ry: 0.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 466.62,
    y: 583.41,
    width: 33.94,
    height: 10.54,
    rx: 1.08,
    ry: 1.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 508.19,
    y: 583.41,
    width: 33.94,
    height: 10.54,
    rx: 1.08,
    ry: 1.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 550.76,
    y: 583.41,
    width: 33.94,
    height: 10.54,
    rx: 0.79,
    ry: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 593.25,
    y: 583.41,
    width: 33.94,
    height: 10.54,
    rx: 0.79,
    ry: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 636.36,
    y: 583.41,
    width: 33.94,
    height: 10.54,
    rx: 0.88,
    ry: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 678.93,
    y: 583.41,
    width: 33.94,
    height: 10.54,
    rx: 0.88,
    ry: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 721.42,
    y: 583.41,
    width: 32.68,
    height: 10.54,
    rx: 0.87,
    ry: 0.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 763.29,
    y: 583.41,
    width: 32.68,
    height: 10.54,
    rx: 0.87,
    ry: 0.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 804.75,
    y: 583.41,
    width: 32.68,
    height: 10.54,
    rx: 1.46,
    ry: 1.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 366.6,
    y: 567.4,
    width: 37.9,
    height: 10.54,
    rx: 0.86,
    ry: 0.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 412.65,
    y: 567.4,
    width: 37.7,
    height: 10.54,
    rx: 0.86,
    ry: 0.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 457.48,
    y: 567.4,
    width: 37.81,
    height: 10.54,
    rx: 1.08,
    ry: 1.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 505.34,
    y: 567.4,
    width: 38.55,
    height: 10.54,
    rx: 1.08,
    ry: 1.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 552.04,
    y: 567.4,
    width: 37.5,
    height: 10.54,
    rx: 0.79,
    ry: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 596.66,
    y: 567.4,
    width: 39.69,
    height: 10.54,
    rx: 0.79,
    ry: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 644.15,
    y: 567.4,
    width: 38.51,
    height: 10.54,
    rx: 0.88,
    ry: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 691.01,
    y: 567.4,
    width: 35.86,
    height: 10.54,
    rx: 0.88,
    ry: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 733.81,
    y: 567.4,
    width: 38.51,
    height: 10.54,
    rx: 0.87,
    ry: 0.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 779.63,
    y: 567.4,
    width: 35.48,
    height: 10.54,
    rx: 0.87,
    ry: 0.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 821.09,
    y: 567.4,
    width: 37.55,
    height: 10.54,
    rx: 1.46,
    ry: 1.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 282.11,
    y: 553.43,
    width: 35.99,
    height: 8.81,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 330.7,
    y: 553.43,
    width: 35.99,
    height: 8.81,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 379.29,
    y: 553.43,
    width: 35.99,
    height: 8.81,
    rx: 0.86,
    ry: 0.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 427.88,
    y: 553.43,
    width: 35.99,
    height: 8.81,
    rx: 0.86,
    ry: 0.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 476.47,
    y: 553.43,
    width: 35.99,
    height: 8.81,
    rx: 1.08,
    ry: 1.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 525.06,
    y: 553.43,
    width: 35.99,
    height: 8.81,
    rx: 1.08,
    ry: 1.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 573.65,
    y: 553.43,
    width: 35.99,
    height: 8.81,
    rx: 0.79,
    ry: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 619.98,
    y: 553.43,
    width: 35.99,
    height: 8.81,
    rx: 0.88,
    ry: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 668.57,
    y: 553.43,
    width: 40.37,
    height: 8.81,
    rx: 0.88,
    ry: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 719.42,
    y: 553.43,
    width: 35.99,
    height: 8.81,
    rx: 0.87,
    ry: 0.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 768.01,
    y: 553.43,
    width: 35.99,
    height: 8.81,
    rx: 0.87,
    ry: 0.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 816.6,
    y: 553.43,
    width: 35.99,
    height: 8.81,
    rx: 1.46,
    ry: 1.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 282.27,
    y: 542.22,
    width: 37.56,
    height: 7.09,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 331.55,
    y: 542.22,
    width: 37.56,
    height: 7.09,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 380.83,
    y: 542.22,
    width: 37.56,
    height: 7.09,
    rx: 0.86,
    ry: 0.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 427.88,
    y: 542.22,
    width: 37.56,
    height: 7.09,
    rx: 0.86,
    ry: 0.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 477.16,
    y: 542.22,
    width: 37.56,
    height: 7.09,
    rx: 1.08,
    ry: 1.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 526.44,
    y: 542.22,
    width: 37.56,
    height: 7.09,
    rx: 1.08,
    ry: 1.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 572.18,
    y: 542.22,
    width: 37.56,
    height: 7.09,
    rx: 0.79,
    ry: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 619.98,
    y: 542.22,
    width: 37.56,
    height: 7.09,
    rx: 0.88,
    ry: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 669.26,
    y: 542.22,
    width: 37.56,
    height: 7.09,
    rx: 0.88,
    ry: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 717.17,
    y: 542.22,
    width: 37.56,
    height: 7.09,
    rx: 0.87,
    ry: 0.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 766.45,
    y: 542.22,
    width: 37.56,
    height: 7.09,
    rx: 0.87,
    ry: 0.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 813.97,
    y: 542.22,
    width: 37.56,
    height: 7.09,
    rx: 1.46,
    ry: 1.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m330.68,157.66h485.93v291.13c0,5.33-4.32,9.65-9.65,9.65h-466.64c-5.33,0-9.65-4.32-9.65-9.65V157.66h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m568.47,191.85l6.27,7.29-8.38,51.7-2.13,4.49,5.41-2.03,5.73,5.66-5.78,58.75s-7.37,28.3-8.05,28.87,10.04,64.42,10.04,64.42l-49.11-46.94,13.54-123.96,32.46-48.25Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "333.17 91.27 459.65 500.44 514.2 500.44 385.25 91.27 333.17 91.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "561.93 350.66 594.31 323.46 593.18 320.13 545.08 329.14 561.93 350.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m514.23,374.39l-.75-28.14c25.25-.67,32.67-18.21,43.62-48.82,3.46-9.65,6.99-19.5,11.64-28.66l.9-15.48-9.01-6.75,7.83-54.7-113.43,3.01,5.83,219.24,110.96-2.95-13.94-54.25c-11.44,11.15-26.09,17.02-43.66,17.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m593.18,320.13l-12.65-2.04c-2.57,6.78-5.43,13.62-8.88,20.03l21.53-18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m513.48,346.25l.75,28.14c17.56-.47,32.21-6.34,43.66-17.49l-1.54-5.98,15.3-12.79c3.46-6.41,6.31-13.26,8.88-20.03l-14.53-2.34,2.74-46.98c-4.65,9.16-8.18,19.01-11.64,28.66-10.94,30.61-18.36,48.15-43.62,48.82Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "423.69 91.27 550.16 500.44 604.72 500.44 475.76 91.27 423.69 91.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m340.33,135.84h466.64c5.33,0,9.65,4.32,9.65,9.65v17.58h-485.93v-17.58c0-5.33,4.32-9.65,9.65-9.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m589.32,193.13l-13.09,53.68,8.31,7.59-2.4,15.32h0c3.12-4.89,6.56-9.53,10.53-13.73,13.61-14.39,31.09-20.92,51.89-19.45l-1.98,28.08c-19.27-1.36-29.08,7.83-38.86,25.47l21.92,1.55-1.98,28.08-33.29-2.35c-.42.86-.84,1.73-1.27,2.59l12.39,3.25-23.17,15.83s-.05.08-.08.11c-.52.77-1.05,1.53-1.58,2.28-.19.27-.39.54-.58.81-.21.29-.42.58-.63.86-.25.34-.51.68-.77,1.01-.17.22-.33.43-.5.65-.41.53-.84,1.05-1.26,1.57-.15.18-.3.36-.45.53-.33.39-.66.79-1,1.17-.14.17-.29.33-.44.5-.47.53-.95,1.06-1.44,1.58-.5.52-1,1.03-1.5,1.54-.14.14-.29.28-.43.42-.38.37-.77.74-1.15,1.1-.14.13-.29.27-.43.4-.44.41-.89.81-1.35,1.2-.08.07-.15.13-.23.2-.56.48-1.13.95-1.7,1.41l8.62,55.35,113.88,8.04,15.44-218.77-111.42-7.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m571.46,348.03c-.14.17-.29.33-.44.5.15-.16.29-.33.44-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m567.65,352.06c-.38.37-.77.74-1.15,1.1.39-.36.77-.73,1.15-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m572.91,346.32c-.15.18-.3.36-.45.53.15-.18.3-.36.45-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m566.06,353.57c-.44.41-.89.81-1.35,1.2.45-.39.9-.79,1.35-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m574.67,344.1c-.17.22-.33.43-.5.65.17-.21.33-.43.5-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m562.79,356.37c.57-.46,1.14-.93,1.7-1.41-.56.48-1.13.95-1.7,1.41h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m569.58,350.1c-.5.52-1,1.03-1.5,1.54.51-.5,1.01-1.01,1.5-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m576.07,342.23c-.21.29-.42.58-.63.86.21-.29.42-.57.63-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m578.23,339.14c-.52.77-1.05,1.53-1.58,2.28.54-.75,1.06-1.51,1.58-2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m589.09,319.94h0c.43-.87.85-1.73,1.27-2.59l33.29,2.35,1.98-28.08-21.92-1.55c9.78-17.64,19.59-26.83,38.86-25.47l1.98-28.08c-20.8-1.47-38.28,5.06-51.89,19.45-3.96,4.2-7.41,8.84-10.53,13.73l-7.28,46.49,14.23,3.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m520.03,369.68c-.19,0-.39-.01-.58-.02.19,0,.39.02.58.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m520.03,369.68c-.19,0-.39-.01-.58-.02.19,0,.39.02.58.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "578.31 339.02 578.31 339.02 578.31 339.02 578.31 339.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "582.14 269.71 582.14 269.71 582.14 269.71 582.14 269.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m576.65,341.42c-.19.27-.39.54-.58.81.2-.27.39-.54.58-.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m575.43,343.09c-.25.34-.51.68-.77,1.01.26-.34.51-.67.77-1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m574.17,344.75c-.41.53-.84,1.05-1.26,1.57.43-.52.85-1.04,1.26-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m572.46,346.86c-.33.39-.66.79-1,1.17.34-.39.67-.78,1-1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m571.02,348.53c-.47.53-.95,1.06-1.44,1.58.49-.52.97-1.05,1.44-1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m578.23,339.14s.05-.08.08-.11h0s-.05.08-.08.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m564.72,354.77c-.08.07-.15.13-.23.2.08-.07.15-.13.23-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m566.5,353.16c-.14.13-.29.27-.43.4.15-.13.29-.27.43-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m568.08,351.64c-.14.14-.29.28-.43.42.14-.14.29-.28.43-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m561.84,350.27l.95,6.1c.57-.46,1.14-.93,1.7-1.41.08-.07.15-.13.23-.2.45-.39.9-.79,1.35-1.2.15-.13.29-.27.43-.4.39-.36.77-.73,1.15-1.1.14-.14.29-.28.43-.42.51-.5,1.01-1.01,1.5-1.54.49-.52.97-1.05,1.44-1.58.15-.16.29-.33.44-.5.34-.39.67-.78,1-1.17.15-.18.3-.36.45-.53.43-.52.85-1.04,1.26-1.57.17-.21.33-.43.5-.65.26-.34.51-.67.77-1.01.21-.29.42-.57.63-.86.2-.27.39-.54.58-.81.54-.75,1.06-1.51,1.58-2.28.03-.04.05-.08.08-.11l-16.47,11.25Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 345.28,
    cy: 149.45,
    r: 4.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 360.76,
    cy: 149.45,
    r: 4.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 376.23,
    cy: 149.45,
    r: 4.81
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path32",
    className: "cls-7",
    d: "m799.47,150.59v-1.76l-.45.34-.29-.4.79-.58h.52v2.39h-.56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    className: "cls-7",
    d: "m801.79,149.38c0-.07,0-.16-.01-.25,0-.09-.03-.17-.05-.25-.02-.08-.06-.14-.11-.2-.05-.05-.11-.08-.18-.08s-.14.03-.18.08c-.05.05-.08.12-.11.2-.03.08-.04.16-.05.25,0,.09-.01.17-.01.25s0,.16.01.25c0,.09.03.18.05.25.03.08.06.14.11.2.05.05.11.08.18.08s.13-.03.18-.08c.05-.05.08-.12.11-.2.02-.08.04-.16.05-.25,0-.09.01-.18.01-.25Zm.58,0c0,.17-.02.33-.05.48-.03.15-.09.29-.16.4-.07.12-.17.21-.29.28-.12.07-.26.1-.43.1s-.31-.03-.43-.1c-.12-.07-.22-.16-.29-.28-.08-.12-.13-.25-.16-.4-.03-.15-.05-.31-.05-.48s.02-.33.05-.48c.03-.15.09-.29.16-.4.08-.11.17-.2.29-.27.12-.07.26-.1.43-.1s.31.03.43.1c.12.07.21.16.29.27.07.11.13.25.16.4.03.15.05.31.05.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    className: "cls-7",
    d: "m805.55,150.59v-1.76l-.45.34-.29-.4.79-.58h.52v2.39h-.56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    className: "cls-7",
    d: "m807.87,149.38c0-.07,0-.16-.01-.25,0-.09-.03-.17-.05-.25-.02-.08-.06-.14-.11-.2-.05-.05-.11-.08-.18-.08s-.14.03-.18.08c-.05.05-.08.12-.11.2-.03.08-.04.16-.05.25,0,.09-.01.17-.01.25s0,.16.01.25c0,.09.03.18.05.25.03.08.06.14.11.2.05.05.11.08.18.08s.13-.03.18-.08c.05-.05.08-.12.11-.2.02-.08.04-.16.05-.25,0-.09.01-.18.01-.25Zm.58,0c0,.17-.02.33-.05.48-.03.15-.09.29-.16.4-.07.12-.17.21-.29.28-.12.07-.26.1-.43.1s-.31-.03-.43-.1c-.12-.07-.22-.16-.29-.28-.08-.12-.13-.25-.16-.4-.03-.15-.05-.31-.05-.48s.02-.33.05-.48c.03-.15.09-.29.16-.4s.17-.2.29-.27c.12-.07.26-.1.43-.1s.31.03.43.1c.12.07.21.16.29.27.07.11.13.25.16.4.03.15.05.31.05.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    className: "cls-7",
    d: "m799.42,154.36v-1.76l-.45.34-.29-.4.79-.58h.52v2.39h-.56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    className: "cls-7",
    d: "m801.41,154.36v-1.76l-.45.34-.29-.4.79-.58h.52v2.39h-.56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    className: "cls-7",
    d: "m803.39,154.36v-1.76l-.45.34-.29-.4.79-.58h.52v2.39h-.56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    className: "cls-7",
    d: "m805.81,153.15c0-.07,0-.16-.01-.25,0-.09-.03-.17-.05-.25-.02-.08-.06-.14-.11-.2-.05-.05-.11-.08-.18-.08s-.14.03-.18.08c-.05.05-.08.12-.11.2-.03.08-.04.16-.05.25,0,.09-.01.17-.01.25s0,.16.01.25c0,.09.03.18.05.25.03.08.06.14.11.2.05.05.11.08.18.08s.13-.03.18-.08c.05-.05.08-.12.11-.2.02-.08.04-.16.05-.25,0-.09.01-.18.01-.25Zm.58,0c0,.17-.02.33-.05.48-.03.15-.09.29-.16.4-.07.12-.17.21-.29.28-.12.07-.26.1-.43.1s-.31-.03-.43-.1c-.12-.07-.22-.16-.29-.28-.08-.12-.13-.25-.16-.4-.03-.15-.05-.31-.05-.48s.02-.33.05-.48c.03-.15.09-.28.16-.4.08-.11.17-.2.29-.27.12-.07.26-.1.43-.1s.31.03.43.1c.12.07.21.16.29.27.07.11.13.25.16.4.03.15.05.31.05.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    className: "cls-7",
    d: "m800.56,157.04v-1.28l-.32.25-.21-.29.57-.42h.38v1.74h-.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path50",
    className: "cls-7",
    d: "m803.44,157.04v-1.28l-.32.25-.21-.29.57-.42h.38v1.74h-.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path52",
    className: "cls-7",
    d: "m799.42,156.17c0-.05,0-.11,0-.18,0-.07-.02-.13-.04-.18-.02-.06-.04-.1-.08-.14-.03-.04-.08-.06-.13-.06s-.1.02-.13.06c-.03.04-.06.09-.08.14-.02.06-.03.12-.04.18,0,.07-.01.13-.01.18s0,.12.01.18c0,.07.02.13.04.18.02.06.05.1.08.14.03.04.08.06.13.06s.1-.02.13-.06c.03-.04.06-.09.08-.14.02-.06.03-.12.04-.18,0-.07,0-.13,0-.18Zm.42,0c0,.12-.01.24-.04.35-.02.11-.06.21-.12.29-.05.08-.12.15-.21.2-.09.05-.19.07-.31.07s-.23-.02-.31-.07c-.09-.05-.16-.12-.21-.2-.05-.08-.09-.18-.12-.29-.02-.11-.04-.23-.04-.35s.01-.24.04-.35c.02-.11.06-.21.12-.29.05-.08.13-.15.21-.2.09-.05.19-.07.31-.07s.23.02.31.07c.09.05.16.12.21.2.05.08.09.18.12.29.02.11.04.23.04.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54",
    className: "cls-7",
    d: "m802.31,156.17c0-.05,0-.11,0-.18,0-.07-.02-.13-.04-.18-.02-.06-.04-.1-.08-.14-.03-.04-.08-.06-.13-.06s-.1.02-.13.06c-.03.04-.06.09-.08.14-.02.06-.03.12-.04.18,0,.07-.01.13-.01.18s0,.12.01.18c0,.07.02.13.04.18.02.06.05.1.08.14.03.04.08.06.13.06s.1-.02.13-.06c.03-.04.06-.09.08-.14.02-.06.03-.12.04-.18,0-.07,0-.13,0-.18Zm.42,0c0,.12-.01.24-.04.35-.02.11-.06.21-.12.29-.05.08-.12.15-.21.2-.09.05-.19.07-.31.07s-.23-.02-.31-.07c-.09-.05-.16-.12-.21-.2-.05-.08-.09-.18-.12-.29-.02-.11-.04-.23-.04-.35s.01-.24.04-.35c.02-.11.06-.21.12-.29.05-.08.13-.15.21-.2.09-.05.19-.07.31-.07s.23.02.31.07c.09.05.16.12.21.2.05.08.09.18.12.29.02.11.04.23.04.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path56",
    className: "cls-7",
    d: "m808.22,157.04v-1.28l-.32.25-.21-.29.57-.42h.38v1.74h-.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path58",
    className: "cls-7",
    d: "m807.09,156.17c0-.05,0-.11,0-.18,0-.07-.02-.13-.04-.18-.02-.06-.04-.1-.08-.14-.03-.04-.08-.06-.13-.06s-.1.02-.13.06c-.03.04-.06.09-.08.14-.02.06-.03.12-.04.18,0,.07-.01.13-.01.18s0,.12.01.18c0,.07.02.13.04.18.02.06.05.1.08.14.03.04.08.06.13.06s.1-.02.13-.06c.03-.04.06-.09.08-.14.02-.06.03-.12.04-.18,0-.07,0-.13,0-.18Zm.42,0c0,.12-.01.24-.04.35-.02.11-.06.21-.12.29-.05.08-.12.15-.21.2-.09.05-.19.07-.31.07s-.23-.02-.31-.07c-.09-.05-.16-.12-.21-.2-.05-.08-.09-.18-.12-.29-.02-.11-.04-.23-.04-.35s.01-.24.04-.35c.02-.11.06-.21.12-.29.05-.08.13-.15.21-.2.09-.05.19-.07.31-.07s.23.02.31.07c.09.05.16.12.21.2.05.08.09.18.12.29.02.11.04.23.04.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path60",
    className: "cls-7",
    d: "m806.64,159.09v-1.28l-.32.25-.21-.29.57-.42h.38v1.74h-.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path62",
    className: "cls-7",
    d: "m805.51,158.21c0-.05,0-.11,0-.18,0-.07-.02-.13-.04-.18-.02-.06-.04-.1-.08-.14-.03-.04-.08-.06-.13-.06s-.1.02-.13.06c-.03.04-.06.09-.08.14-.02.06-.03.12-.04.18,0,.07-.01.13-.01.18s0,.12.01.18c0,.07.02.13.04.18.02.06.05.1.08.14.03.04.08.06.13.06s.1-.02.13-.06c.03-.04.06-.09.08-.14.02-.06.03-.12.04-.18,0-.07,0-.13,0-.18Zm.42,0c0,.12-.01.24-.04.35-.02.11-.06.21-.12.29-.05.08-.12.15-.21.2-.09.05-.19.07-.31.07s-.23-.02-.31-.07c-.09-.05-.16-.12-.21-.2-.05-.08-.09-.18-.12-.29-.02-.11-.04-.23-.04-.35s.01-.24.04-.35c.02-.11.06-.21.12-.29.05-.08.13-.15.21-.2.09-.05.19-.07.31-.07s.23.02.31.07c.09.05.16.12.21.2.05.08.09.18.12.29.02.11.04.23.04.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path64",
    className: "cls-7",
    d: "m799.99,159.06v-.88l-.22.17-.15-.2.4-.29h.26v1.2h-.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path66",
    className: "cls-7",
    d: "m799.21,158.46s0-.08,0-.12c0-.05-.01-.09-.03-.13-.01-.04-.03-.07-.05-.1-.02-.03-.05-.04-.09-.04s-.07.01-.09.04c-.02.03-.04.06-.06.1-.01.04-.02.08-.03.13,0,.05,0,.09,0,.12s0,.08,0,.13c0,.05.01.09.03.13.01.04.03.07.06.1.02.03.05.04.09.04s.07-.01.09-.04c.02-.03.04-.06.05-.1.01-.04.02-.08.03-.13,0-.05,0-.09,0-.13Zm.29,0c0,.08,0,.17-.03.24-.02.08-.04.14-.08.2-.04.06-.09.1-.15.14-.06.03-.13.05-.22.05s-.16-.02-.22-.05c-.06-.03-.11-.08-.15-.14-.04-.06-.07-.13-.08-.2-.02-.08-.03-.16-.03-.24s0-.17.03-.24c.02-.08.04-.14.08-.2.04-.06.09-.1.15-.14.06-.03.13-.05.22-.05s.16.02.22.05c.06.03.11.08.15.14.04.06.06.12.08.2.02.08.03.16.03.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path68",
    className: "cls-7",
    d: "m803.53,160.61v-.88l-.22.17-.15-.2.4-.29h.26v1.2h-.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path70",
    className: "cls-7",
    d: "m802.74,160s0-.08,0-.12c0-.05-.01-.09-.03-.13s-.03-.07-.05-.1c-.02-.03-.05-.04-.09-.04s-.07.01-.09.04c-.02.03-.04.06-.06.1-.01.04-.02.08-.03.13,0,.05,0,.09,0,.12s0,.08,0,.13c0,.05.01.09.03.13.01.04.03.07.06.1.02.03.05.04.09.04s.07-.01.09-.04c.02-.03.04-.06.05-.1.01-.04.02-.08.03-.13,0-.05,0-.09,0-.13Zm.29,0c0,.08,0,.17-.03.24-.02.08-.04.14-.08.2-.04.06-.09.11-.15.14-.06.03-.13.05-.22.05s-.16-.02-.22-.05c-.06-.03-.11-.08-.15-.14-.04-.06-.07-.13-.08-.2-.02-.08-.03-.16-.03-.24s0-.17.03-.24c.02-.08.04-.14.08-.2.04-.06.09-.1.15-.14.06-.03.13-.05.22-.05s.16.02.22.05c.06.03.11.08.15.14.04.06.06.12.08.2.02.08.03.16.03.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path72",
    className: "cls-7",
    d: "m808.38,158.21c0-.05,0-.11,0-.18,0-.07-.02-.13-.04-.18-.02-.06-.04-.1-.08-.14-.03-.04-.08-.06-.13-.06s-.1.02-.13.06c-.03.04-.06.09-.08.14-.02.06-.03.12-.04.18,0,.07,0,.13,0,.18s0,.12,0,.18c0,.07.02.13.04.18.02.06.05.1.08.14.03.04.08.06.13.06s.1-.02.13-.06c.03-.04.06-.09.08-.14.02-.06.03-.12.04-.18,0-.07,0-.13,0-.18Zm.42,0c0,.12-.01.24-.04.35-.02.11-.06.21-.12.29-.05.08-.12.15-.21.2-.09.05-.19.07-.31.07s-.23-.02-.31-.07c-.09-.05-.16-.12-.21-.2-.05-.08-.09-.18-.12-.29-.02-.11-.04-.23-.04-.35s.01-.24.04-.35c.02-.11.06-.21.12-.29.05-.08.13-.15.21-.2.09-.05.19-.07.31-.07s.23.02.31.07c.09.05.16.12.21.2.05.08.09.18.12.29.02.11.04.23.04.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path74",
    className: "cls-7",
    d: "m807.59,146.48c-.4-1.96-2.14-3.38-4.15-3.38-.3,0-.6.03-.9.1-.49-2.85-2.98-5.03-5.97-5.03s-5.43,2.14-5.95,4.96c-2.15.2-3.85,2.01-3.85,4.21,0,2.33,1.9,4.23,4.23,4.23h6.33c.32,0,.59-.26.59-.59s-.26-.59-.59-.59h-6.33c-1.69,0-3.06-1.37-3.06-3.06s1.37-3.06,3.06-3.06c.61,0,1.21.18,1.71.52.27.18.63.11.81-.16.18-.27.11-.63-.16-.81-.48-.32-1.01-.54-1.57-.65.48-2.19,2.44-3.84,4.77-3.84,2.49,0,4.55,1.87,4.85,4.28-.16.09-.31.18-.46.28-.26.19-.32.55-.13.82.19.26.56.32.82.13.52-.38,1.14-.58,1.79-.58,1.45,0,2.71,1.03,3,2.44.06.28.3.47.57.47.04,0,.08,0,.12-.01.32-.06.52-.37.46-.69"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopic31);
export default __webpack_public_path__ + "static/media/topic3.1.dcc81c742778eb1383d86846771ae3e6.svg";
export { ForwardRef as ReactComponent };